<template>
	<div id="songs-filter">
		<IconClockBack :class="{ active: songsFilterNonPlayed }" @click.native="toggleFilterNonPlayed" />
		<p v-if="songsFilterNonPlayed" v-html="$t('song.filter.nonPlayed')"></p>
	</div>
</template>

<script>
	import IconClockBack from "@/components/icons/IconClockBack";
	import { mapState } from "vuex";

	export default {
		data() {
			return {
			}
		},
		components: {
			IconClockBack
		},
		computed: {
			...mapState([ "songsFilterNonPlayed", "songsFilter" ])
		},
		methods: {
			toggleFilterNonPlayed() {
				this.$store.commit("setSongsFilterNonPlayed", !this.songsFilterNonPlayed);
			}
		}
	}
</script>

<style lang="scss" scoped>
	#songs-filter {
		height: 50px;

		p {
			font-size: 0.7em;
			float: left;
			width: 125px;
			color: rgba(255, 255, 255, 0.81);
			text-align: center;
			padding: 1px 0 0 0;
			line-height: 1.2em;
		}

		.icon-clock-back {
			float: left;
		}

		.icon {
			padding: 9px 15px 0 15px;
			fill: rgba(255, 255, 255, 0.47);
			cursor: pointer;
			width: 33px;
			height: 33px;

			&.active {
				fill: rgba(244,162,97,1);
			}
		}
	}
</style>
